import { render, staticRenderFns } from "./couponPropertyPoolDetailList.vue?vue&type=template&id=2446ec92&scoped=true"
import script from "./couponPropertyPoolDetailList.vue?vue&type=script&lang=js"
export * from "./couponPropertyPoolDetailList.vue?vue&type=script&lang=js"
import style0 from "./couponPropertyPoolDetailList.vue?vue&type=style&index=0&id=2446ec92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2446ec92",
  null
  
)

export default component.exports